import "../css/blockimagevideo.css";
import { useState, useEffect } from "react";

function BlockImageVideo(props) {
  const [width, setWidth] = useState(window.innerWidth);
  const mystyle = {
    backgroundImage: `url(${props.src})`,
  };

  const updateWindowDimensions = () => {
    const newW = window.innerWidth;
    setWidth(newW);
    // console.log('updating height');
  };

  useEffect(() => {
    window.addEventListener("resize", updateWindowDimensions);
    // console.log("give height", height);
  }, []);
  return (
    <>
      <div className="wrapper-block-video" style={mystyle}>
        {width > 900 && (
          <video autoPlay muted loop height="100%">
            <source src={props.video} type="video/mp4" />
            Sorry, your browser doesn't support embedded videos.
          </video>
        )}

        <div className="wrapper-block-content">
          <div>
            <div> {props.content}</div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlockImageVideo;
